import { useSelector } from 'react-redux';

const useUserClaims = () => {
  const { session } = useSelector(state => state.user);

  return session?.claims ?? [];
};

export default useUserClaims;
